import Icon from '../components/Icon.vue'

Icon.register({"black-tie":{"width":1536,"height":1792,"paths":[{"d":"M0 128h1536v1536h-1536v-1536zM1085 1243l-221-631 221-297h-634l221 297-221 631 317 304z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/black-tie.js
// module id = 746
// module chunks = 0